export default {
  submit: {
    is: 'Panta tíma',
    en: 'Make an appointment',
  },
  continue: {
    is: 'Áfram',
    en: 'Continue',
  },
  phoneErrorMessage: { is: 'Símanúmer er ekki á réttu formi' },
  emailErrorMessage: { is: 'Netfang er ekki á réttu formi' },
  nameErrorMessage: {
    is: 'Nafn verður að vera útfyllt',
    en: 'Name is a required.',
  },
  additionalCustomer: {
    is: 'Mæti með maka',
    en: 'With spouse',
  },
};
